import dayjs from 'dayjs';
import 'dayjs/locale/es';
import updateLocale from 'dayjs/plugin/updateLocale';
import { dayjsLocalizer } from 'react-big-calendar';
import type { Messages } from 'react-big-calendar';

import type { Language, Translations } from '@/lib/i18n';
import { fillTemplate } from '@/lib/utils';

// `dayjsLocalizer(dayjs)` extends the plugins it needs itself (isBetween,
// isSameOrAfter/Before, localeData, localizedFormat, minMax, utc, isLeapYear).
// The one thing it does NOT do is normalise the first day of the week: dayjs's
// `es` locale ships Monday, so without this the RBC month grid would start on a
// different weekday than `getCalendarMatrix` (Sunday) uses to compute the fetch
// window — dropping edge-of-month occurrences. Force Sunday for both locales.
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 0 });
dayjs.updateLocale('es', { weekStart: 0 });

export const localizer = dayjsLocalizer(dayjs);

/** RBC's `messages` prop, wired to the app's i18n dictionary. */
export function calendarMessages(t: Translations): Messages {
  return {
    today: t.today,
    previous: t.calendarPrevMonth,
    next: t.calendarNextMonth,
    month: t.calendarViewMonth,
    agenda: t.calendarViewAgenda,
    date: t.calendarAgendaDate,
    time: t.calendarAgendaTime,
    event: t.calendarAgendaEvent,
    allDay: t.calendarAllDay,
    noEventsInRange: t.calendarNoEventsRange,
    showMore: (count: number) => fillTemplate(t.calendarMore, { n: count }),
  };
}

/** The BCP-47-ish culture string RBC hands to the localizer's formatters. */
export function calendarCulture(language: Language): string {
  return language;
}
